
import GenderIcon from './gender-icon'
import Datetime from '../../admin/components/datetime'
export default
  name: 'live-finish'
  components: {GenderIcon, Datetime}
  props:
    href: String
    race_id: [Number, Array]
    limit: {type: Number, default: 120}
    tz: {type: String, default: 'Europe/Moscow'}
  data: ->
    heats: []
    fields: [
      {key: 'bib', label: i18n.t('bib')},
      {key: 'name', label: i18n.t('name'), isRowHeader: true},
      {key: 'absolute', label: i18n.t('passing_time')},
      {key: 'result', label: i18n.t('result')},
      {key: 'status', label: i18n.t('status')},
      {key: 'rank', label: i18n.t('rank')}
    ]
  created: ->
    events =
      received: (data) ->
        if data.heat?
          @heats.unshift(data.heat)
          @heats.pop() if @limit < @heats.length

    if Array.isArray(@race_id)
      for id in @race_id
        @$cable._addChannel("LiveFinishChannel_#{id}", events, @)
    else
      @$cable._addChannel("LiveFinishChannel_#{@race_id}", events, @)

  beforeDestroy: ->
    if Array.isArray(@race_id)
      for id in @race_id
        @$cable._removeChannel("LiveFinishChannel_#{id}")
    else
      @$cable._removeChannel("LiveFinishChannel_#{@race_id}")

  mounted: ->
    @refresh() if 0 == @heats.length
    if Array.isArray(@race_id)
      for id in @race_id
        @$cable.subscribe({channel: 'LiveFinishChannel', race_id: id}, "LiveFinishChannel_#{id}")
    else
      @$cable.subscribe({channel: 'LiveFinishChannel', race_id: @race_id}, "LiveFinishChannel_#{@race_id}")

  methods:
    refresh: ->
      @axios.get(@href)
        .then (res) => @heats = res.data.heats
        .catch (e) -> console.log e

